'use client';

import React from 'react';
import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useTabContext } from '@/components/context/TabContext';

const SPECIAL_BREADCRUMB_PATHS = [
  '/professionals/resources/academy/marketing-guides',
  '/professionals/resources/academy/later-life-lending-guides',
];

const Breadcrumb = ({ items = [], showHomeIcon = true, lastItemClickable = false }) => {
  const pathname = usePathname();
  const hasCustomBreadcrumb = SPECIAL_BREADCRUMB_PATHS.includes(pathname);
  const { selectedTab } = useTabContext();

  return (
    <nav aria-label="Breadcrumb" className="flex items-center space-x-2 text-base">
      {showHomeIcon && (
        <Link href={selectedTab === 'adviser' ? '/professionals' : '/'} className="flex items-center hover:text-blue-600 transition-colors">
          {selectedTab === 'adviser'
            ? <img src={` ${hasCustomBreadcrumb ? '/img/icons/home-line-02.svg' : '/img/icons/home-line.svg'}`} className="w-4 h-4" alt="home"/>
            : <img src="/img/icons/home-line-alt.svg" className="w-4 h-4" alt="home"/>
          }
        </Link>
      )}

      {items.map((item, index) => (
        <React.Fragment key={item.href || index}>
          <ChevronRight className="w-4 h-4 text-[#CBCDD6]" />
          {index === items.length - 1 ? (
            lastItemClickable
              ? <a
                href={item.href || '#'}
                className={`${index === items.length - 1
                  ? selectedTab === 'adviser'
                    ? 'text-[#006EB7]'
                    : 'text-[#A51367]'
                  : 'text-[#373945]'
                } text-base font-semibold hover:underline
                `}
                aria-current={index === items.length - 1 ? 'page' : undefined}
                aria-label={item.label}
              >
                <span className={`${selectedTab === 'adviser' ? 'text-[#006EB7]' : 'text-[#A51367]'} text-base font-semibold`} aria-current="page">
                  <span className="lg:hidden">{item.labelMobile || item.label}</span>
                  <span className="hidden lg:inline">{item.label}</span>
                </span>
              </a>
              : <span className={`${selectedTab === 'adviser' ? 'text-[#006EB7]' : 'text-[#A51367]'} text-base font-semibold`} aria-current="page">
                <span className="lg:hidden">{item.labelMobile || item.label}</span>
                <span className="hidden lg:inline">{item.label}</span>
              </span>
          ) : (
            <a
              href={item.href || '#'}
              className={`${index === items.length - 1 ? 'text-[#006EB7]' : 'text-[#373945]'} text-base font-semibold hover:underline`}
              aria-current={index === items.length - 1 ? 'page' : undefined}
            >
              <span className={`${
                hasCustomBreadcrumb
                  ? item.label === 'Resources' || item.labelMobile === 'Resources'
                    ? 'text-[#F3F3F8]'
                    : 'text-[#007DD1]'
                  : ''
              } lg:hidden`}>
                {item.labelMobile || item.label}
              </span>
              <span className={`${
                hasCustomBreadcrumb
                  ? item.label === 'Resources'
                    ? 'text-[#F3F3F8]'
                    : 'text-[#007DD1]'
                  : ''
              } hidden lg:inline`}>{item.label}</span>
            </a>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
